import { ref } from 'vue'

import { defineStore } from 'pinia'

import { ProfileSteps } from '@/constant/user'

export const useFEUserProfileStore = defineStore('feUserProfile', () => {
  const $reset = () => {}

  const currentStep = ref<ProfileSteps>(ProfileSteps.PROFILE_INFO)
  const updateCurrentStep = (newStep: ProfileSteps) => {
    currentStep.value = newStep
  }

  const currentCorrelationId = ref('')
  const setCurrentCorrelationId = (newCurrentCorrelationId?: string) => {
    if (!newCurrentCorrelationId) {
      currentCorrelationId.value = ''
      return
    }
    currentCorrelationId.value = newCurrentCorrelationId
  }

  const newUserEmail = ref('')
  const setNewUserEmail = (newmail: string) => {
    newUserEmail.value = newmail
  }

  const userPhoneNumber = ref('')
  const setUserPhoneNumber = (phone?: string | null) => {
    if (!phone) {
      userPhoneNumber.value = ''
      return
    }
    userPhoneNumber.value = phone
  }

  return {
    $reset,
    currentStep,
    updateCurrentStep,
    currentCorrelationId,
    setCurrentCorrelationId,
    newUserEmail,
    setNewUserEmail,
    userPhoneNumber,
    setUserPhoneNumber
  }
})
